const TIER_DEFAULTS = {
    tierA: {
        intervalPcs: 20000,
        tasks: [
            { description: 'Clean gas burns and venting slots' },
            { description: 'Inspect & lubricate slides, lifters, & angle pins' },
            { description: 'Check ejector plate and pin alignment' },
            { description: 'Check flow rate & leak test' },
            { description: 'Critical dimension point' }
        ]
    },
    tierB: {
        intervalPcs: 50000,
        tasks: [
            { description: 'Pull core/cavity inserts & slides' },
            { description: 'Descaling & pressure test' },
            { description: 'Inspect nozzle tips, heater bands, and thermocouples' },
            { description: 'Check guide bushings, leader pins, and wear plates' },
            { description: 'Inspect high-temp O-rings on water channels' }
        ]
    },
    tierC: {
        intervalPcs: 100000,
        tasks: [
            { description: 'Strip mold down to base plates' },
            { description: 'Measure critical tool dimensions & cavity wear' },
            { description: 'Wear & Tear Items' },
            { description: 'Inspect cavity surface polish / SPI finish' }
        ]
    }
};

function createTasks(tasks) {
    const filledTasks = tasks.map((task, index) => ({
        seq: index + 1,
        description: task.description,
        photoUrls: []
    }));

    while (filledTasks.length < 10) {
        filledTasks.push({ seq: filledTasks.length + 1, description: '', photoUrls: [] });
    }

    return filledTasks;
}

export function createTpmDefaults() {
    return {
        tierA: { intervalPcs: TIER_DEFAULTS.tierA.intervalPcs, tasks: createTasks(TIER_DEFAULTS.tierA.tasks) },
        tierB: { intervalPcs: TIER_DEFAULTS.tierB.intervalPcs, tasks: createTasks(TIER_DEFAULTS.tierB.tasks) },
        tierC: { intervalPcs: TIER_DEFAULTS.tierC.intervalPcs, tasks: createTasks(TIER_DEFAULTS.tierC.tasks) }
    };
}
